
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import ResponsiveDialog from "./responsive-dialog.vue";

export default {
  components: { ResponsiveDialog },
  props: {
    dialog: Boolean
  },
  data() {
    return {
      valid: false,
      characterExceededItemList: [],
      characterLimitRule: [(v) => v?.length <= 70 || "Max 70 characters"]
    };
  },
  beforeMount() {
    this.characterExceededItemList = JSON.parse(
      JSON.stringify(this.menuUploadExceededCharLimitList)
    );
  },
  computed: {
    ...mapState("menu", ["menuUploadExceededCharLimitList", "menuUploadList"])
  },
  methods: {
    ...mapMutations("menu", ["SET_MENU_UPLOAD_LIST_SINGLE_ITEM_PROP"]),
    saveChanges() {
      this.characterExceededItemList.forEach((element) => {
        const index = this.getMenuUploadItemIndex(
          this.menuUploadList,
          element.id
        );
        if (index !== -1) {
          this.SET_MENU_UPLOAD_LIST_SINGLE_ITEM_PROP({
            index: index,
            propName: "item_name",
            propValue: element.item_name
          });
        }
      });
      this.$emit("character-name-updated");
      this.$emit("close-dialog");
    }
  }
};
